<template>
  <div class="content">
    <h2 class="pl-3">{{ father }} | Alumnos</h2>

    <v-dialog v-model="dialogNuevoAlumno" width="600px">
      <v-card style="overflow:hidden;">
        <v-card-title class="grey lighten-4 py-4 title">{{this.dialogTitulo}}</v-card-title>
        <editarCrearAlumno
          :reset="dialogNuevoAlumno"
          :idAlumno="idAlumnoSeleccionado"
          :alumno="alumnoSeleccionado"
          @editarCrearAlumno:mostrarOcultarDialog="mostrarOcultarDialog"
          @editarCrearAlumno:listarAlumnos="listarAlumnos"
        />
      </v-card>
    </v-dialog>

    <template>
      <v-card class="pa-3 ma-3">
        <v-layout row wrap>
          <v-flex xs3 offset-xs9>
            <v-btn
              color="success"
              @click="editarCrearAlumno('Nuevo Alumno', -1, '')"
            >Añadir Nuevo Alumno</v-btn>
          </v-flex>
        </v-layout>
        <v-card-title>
          <v-row justify="center">
            <v-col cols="6">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar"
                single-line
                hide-details
                solo
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>

        <v-data-table
          :headers="headers"
          :items="alumnos"
          :search="search"
          :loading="loadingDataAlumnos"
          ref="lista_alumnos"
          loading-text="Cargando... Por favor espere"
        >
          <template v-slot:item.estado="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  :class="[item.estado_alumno != '1'? 'redColor' : 'greenColor']"
                >{{(item.estado_alumno!=1)? 'mdi-emoticon-sad-outline': 'mdi-emoticon-excited-outline'}}</v-icon>
              </template>
              <span>{{item.estado_alumno != '1'? 'Deshabilitado' : 'Habilitado'}}</span>
            </v-tooltip>
          </template>

          <template v-slot:item.edit="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  @click="editarCrearAlumno('Editar Alumno', item.idalumno, item)"
                >mdi-pencil</v-icon>
              </template>
              <span>Editar Alumno</span>
            </v-tooltip>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  @click="cambiarEstadoAlumno(item)"
                  :class="[item.estado_alumno != '1'? 'greenColor' : 'redColor']"
                >{{(item.estado_alumno!=1)? 'mdi-check-bold': 'mdi-close-thick'}}</v-icon>
              </template>
              <span>{{item.estado_alumno != '1'? 'Habilitar Alumno' : 'Deshabilitar Alumno'}}</span>
            </v-tooltip>
          </template>

          <template
            v-slot:no-results
            :value="true"
            color="error"
            icon="warning"
          >La búsqueda para "{{ search }}" no obtuvo resultados.</template>
        </v-data-table>
      </v-card>
    </template>
  </div>
</template>        

<script>
import API from "../_config/conf";
import editarCrearAlumno from "./editarCrearAlumno";

export default {
  data() {
    return {
      loadingDataAlumnos: true,
      dialogNuevoAlumno: false,
      dialogTitulo: "",
      idAlumnoSeleccionado: "",
      alumnoSeleccionado: "",
      search: "",
      headers: [
        {
          text: "Apellido",
          sortable: true,
          value: "apellido"
        },
        {
          text: "Nombre",
          align: "left",
          sortable: true,
          value: "nombre"
        },
        { text: "Dni", sortable: false, class: "", value: "dni" },
        { text: "curso", sortable: false, class: "", value: "curso" },
        { text: "", value: "estado", sortable: false, width: 50 },
        { text: "", value: "edit", sortable: false, width: 50 },
        { text: "", value: "actions", sortable: false, width: 50 }
      ],
      alumnos: []
    };
  },
  props: ["father"],
  components: {
    editarCrearAlumno
  },
  mounted: function() {
    this.listarAlumnos();
  },
  methods: {
    mayus(str) {
      let srt_result = API.ucFirst(str);
      return srt_result;
    },
    listarAlumnos() {
      this.loadingDataAlumnos = true;
      let resultado = API.enviar("get", "obtenerAlumnos", "");
      //console.log(this.alumnos.length, this.dialogNuevoAlumno);
      resultado
        .then(result => {
          if (result.data.msj == "ok") this.alumnos = result.data.result;
        })
        .catch(error => {
          console.log(
            "listarAlumnos | methods | listarAlumnos |  catch: -> ",
            error
          );
        })
        .finally(() => {
          this.loadingDataAlumnos = false;
        });
    },
    editarCrearAlumno: function(titulo, idAlumno, alumno) {
      //console.log("editarCrearAlumno: ", idAlumno);
      this.dialogTitulo = titulo;
      this.dialogNuevoAlumno = true;
      this.idAlumnoSeleccionado = idAlumno;
      this.alumnoSeleccionado = alumno;
    },
    cambiarEstadoAlumno: function(elem) {
      //console.log(elem);
      let param = "idAlumno=" + elem.idalumno + "&estado=" + elem.estado_alumno;
      let resultadoEditar = API.enviar("get", "cambiarEstadoAlumno", param);

      resultadoEditar
        .then(() => {
          //console.log("cambiarEstadoAlumno OK");
          this.listarAlumnos();
        })
        .catch(error => {
          console.log("Catch 1 cambiarEstadoAlumno !!!", error);
        });
    },
    mostrarOcultarDialog: function() {
      this.dialogNuevoAlumno = !this.dialogNuevoAlumno;
    }
  }
};
</script>

<style scoped>
.content {
  width: 100%;
}

h2 {
  text-align: left;
  margin-bottom: 10px;
}

.greenColor {
  color: green;
}

.redColor {
  color: red;
}

.v-icon {
  cursor: pointer;
}
</style>